<template>
  <v-container fluid class="pl-15 pr-10 pt-10">
    <div class="d-flex justify-space-between">
      <v-menu
        :value="shown"
        v-model="filter"
        :close-on-content-click="false"
        :nudge-width="100"
        :right="true"
        offset-x
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn flat depressed v-bind="attrs" v-on="on" color="#d8e7f5">
            <v-icon small color="titleText">mdi-filter-variant</v-icon>
            <span class="titleText--text text-capitalize font-weight-bold ml-3"
              >Filter</span
            >
          </v-btn>
        </template>
        <v-card width="900px">
          <v-card-text>
            
            <h4 class="titleText--text mb-3">Select Variable</h4>
            <v-select
              style="border-radius: 8px"
              dense
              color="titleText"
              placeholder="Select"
              solo
              flat
              v-model="IndependentvariablesSelected"
              :items="Independentvariables"
              multiple
              hide-details="auto"
              class="mb-2"
              background-color="#F3F5F8"
            >
              <template v-slot:prepend-item>
                <v-text-field 
                  v-model="searchTerm"
                  placeholder="Search"
                  @input="searchItems"
                  hide-details
                  dense
                  clearable
                  flat
                  solo
                  solo-filled
                  prepend-inner-icon="mdi-magnify"
                />
              </template>
              <template v-slot:selection="{ item }">
                <v-chip small color="blue" text-color="white" class="my-1">
                  <div>
                    <span class="font-weight-bold float-left">{{ item }}</span>
                    <v-btn
                      class="ml-2"
                      dark
                      icon
                      x-small
                      @click.stop="removeVariable(item)"
                      ><v-icon x-small>mdi-close-circle</v-icon></v-btn
                    >
                  </div>
                </v-chip>
              </template>
            </v-select>
            <h4 class="titleText--text my-3">Select Time periods</h4>
            <v-row>
              <v-col cols="4">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="timeRange1"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-combobox
                      v-model="timeRange1"
                      readonly
                      color="titleText"
                      hide-details="auto"
                      placeholder="From date"
                      solo
                      flat
                      background-color="#F3F5F8"
                      v-bind="attrs"
                      v-on="on"
                      multiple
                    >
                      <template v-slot:selection="{ item }">
                        <v-chip
                          small
                          color="blue"
                          text-color="white"
                          class="my-1"
                        >
                          <span class="font-weight-bold float-left">{{
                            item
                          }}</span>
                        </v-chip>
                      </template>
                      <template v-slot:append>
                        <v-icon small color="rgb(80, 93, 111, .4)"
                          >mdi-calendar-blank-outline</v-icon
                        >
                      </template>
                    </v-combobox>
                  </template>
                  <v-date-picker v-model="timeRange1" no-title scrollable range>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu.save(timeRange1)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="4">
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :return-value.sync="timeRange2"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-combobox
                      v-model="timeRange2"
                      readonly
                      color="titleText"
                      hide-details="auto"
                      placeholder="From date"
                      solo
                      flat
                      background-color="#F3F5F8"
                      v-bind="attrs"
                      v-on="on"
                      multiple
                    >
                      <template v-slot:selection="{ item }">
                        <v-chip
                          small
                          color="blue"
                          text-color="white"
                          class="my-1"
                        >
                          <span class="font-weight-bold float-left">{{
                            item
                          }}</span>
                        </v-chip>
                      </template>
                      <template v-slot:append>
                        <v-icon small color="rgb(80, 93, 111, .4)"
                          >mdi-calendar-blank-outline</v-icon
                        >
                      </template>
                    </v-combobox>
                  </template>
                  <v-date-picker v-model="timeRange2" no-title scrollable range>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu2 = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu2.save(timeRange2)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="4">
                <v-menu
                  ref="menu3"
                  v-model="menu3"
                  :close-on-content-click="false"
                  :return-value.sync="timeRange3"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-combobox
                      v-model="timeRange3"
                      readonly
                      color="titleText"
                      hide-details="auto"
                      placeholder="From date"
                      solo
                      flat
                      background-color="#F3F5F8"
                      v-bind="attrs"
                      v-on="on"
                      multiple
                    >
                      <template v-slot:selection="{ item }">
                        <v-chip
                          small
                          color="blue"
                          text-color="white"
                          class="my-1"
                        >
                          <span class="font-weight-bold float-left">{{
                            item
                          }}</span>
                        </v-chip>
                      </template>
                      <template v-slot:append>
                        <v-icon small color="rgb(80, 93, 111, .4)"
                          >mdi-calendar-blank-outline</v-icon
                        >
                      </template>
                    </v-combobox>
                  </template>
                  <v-date-picker v-model="timeRange3" no-title scrollable range>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu3 = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu3.save(timeRange3)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue"
              depressed
              dark
              height="32"
              width="120"
              @click="feachdatanew"
              :loading="isLoading"
              class="mr-2 mb-2"
            >
              <span class="font-weight-bold text-capitalize"
                >Apply</span
              >
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
      <div v-if="isshowdataregion">
              <v-select
                style="border-radius: 8px;width:250px"
                dense
                color="titleText"
                placeholder="Select"
                hide-details="auto"
                solo
                flat
                v-model="dataregionSelected"
                :items="dataregion"
                label="select Region"
                background-color="#F3F5F8"
                class="mb-3"
                @change="feachdatanew()"
              ></v-select>
            </div>
    </div>
    <v-row>
      <v-col cols="12" class="mt-5">
        <app-widget
          title="Explore Data"
          headingicon="true"
          titleicon="mdi-database-arrow-right-outline"
          helpicon="true"
          helpheading="Explore Data"
        >
          <div slot="help-content">
            Explore Data
          </div>
          <div slot="widget-content">
            <BarChart ref="ctrlbarchart" />
          </div>
        </app-widget>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <app-widget
          title="Trend of variable/s over the time"
          headingicon="true"
          titleicon="mdi-database-arrow-right-outline"
          helpicon="true"
          helpheading="Trend of variable/s over the time"
          no-padding
        >
          <div slot="help-content">Trend of variable/s over the time</div>

          <div slot="widget-content">
            <Table ref="ctrltbl" />
          </div>
        </app-widget>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <app-widget
          title=" Outliers within variable"
          headingicon="true"
          titleicon="mdi-database-arrow-right-outline"
          helpicon="true"
          helpheading="Outliers within variable"
        >
          <div slot="help-content">Outliers within variable</div>

          <div slot="widget-content">
            <div class="mt-5">
              <BoxPlot ref="ctrlboxplot" />
            </div>
          </div>
        </app-widget>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <app-widget
          title="Correlation between Variables"
          headingicon="true"
          titleicon="mdi-database-arrow-right-outline"
          helpicon="true"
          helpheading="Correlation between Variables"
        >
          <div slot="help-content">Correlation between Variables</div>

          <div slot="widget-content">
            <div class="mt-5">
              <HeatMap ref="ctrlheatmap" />
            </div>
          </div>
        </app-widget>
      </v-col>
    </v-row>

    <!-- <v-row>
      <v-col>
       
      </v-col>
    </v-row>
    <v-row>
      <v-col
        ><CtrlSummariesdata ref="ctrlsummariesdata"></CtrlSummariesdata
      ></v-col>
    </v-row> -->
  </v-container>
</template>

<script>
import AppWidget from "../../../components/AppWidget.vue";
import Table from "../views/Table.vue";
import BoxPlot from "../views/charts/BoxPlot.vue";
import HeatMap from "../views/charts/Heatmap.vue";
import BarChart from "../views/charts/Bar.vue";
import apifactory from "../api";
import globalclass from "../../../global/globalvar";
import storagefactory from "../../../global/GlobalStrorage";

export default {
  components: {
    Table,
    BoxPlot,
    HeatMap,
    BarChart,
    AppWidget,
  },
  data() {
    return {
      // new data
      Independentvariables: [],
      IndependentvariablesSelected: [],
      dependentvariables: [],
      step2output: [],
      step2output_trend_data: [],
      step2output_statistics_table: [],
      step2output_correlation: [],
      dataregion: [],
      dataregionSelected: [],
      isshowdataregion: false,
      isLoading: false,
      searchTerms: '',
      copiedItems: [],
      //end

      headerTitleIocn: globalclass.ICON_DataExploration,
      prevstepQueryStringParm: [],
      prevstepQueryStringParmUrl: "",
      shown: true,
      filter: false,
      tab: null,
      variableItems: [],
      selectedVariables: ["dv_sales"],
      dates: null,
      tabItems: [
        {
          item: "Explore data",
          text: "Bar Chart and table",
        },
        {
          item: "Trend of the variable/s over the time",
          text: "Line Chart",
        },
        {
          item: "Outliers with in variables",
          text: "Box Plot",
        },
        {
          item: "Is variable follow normal distribution",
          text: "QQ Plot",
        },
        {
          item: "correlation between Variables",
          text: "QQ Plot",
        },
      ],
      data: [],
      qqPlot: [],
      menu: false,
      menu2: false,
      menu3: false,
      iterator: 0,
      timeRange1: [],
      timeRange2: [],
      timeRange3: [],
      maxOfTotalPeriods: null,
      minOfTotalPeriods: null,
      disabled: false,
      charts: [],
      salesChart: [],
      qqPlotChartOptions: {
        chart: {
          height: 250,
          type: "line",
        },
        fill: {
          type: "solid",
        },
        markers: {
          size: [6, 6],
        },
        tooltip: {
          shared: false,
          intersect: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          type: "numeric",
          min: -3,
          max: 4,
          tickAmount: 4,
        },
      },

      // constants
      exploredata_description: "No data",
    };
  },
  computed: {},
  methods: {
    removeVariable(variable) {
      this.IndependentvariablesSelected =
        this.IndependentvariablesSelected.filter((item) => item !== variable);
    },
    searchItems() {
      if (!this.searchTerm) {
        this.Independentvariables = [...this.copiedItems]
      }

      this.Independentvariables = this.copiedItems.filter((item) => {
        return item.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1;
      });
    },
    openctrlsummariesdata() {
      this.$refs.ctrlsummariesdata.openpopup(this.Independentvariables);
    },
    CloseMenu() {
      this.shown = false;
      this.filter = false;
    },
    openProjectSetupCtrl() {
      if (this.shown) {
        this.shown = false;
        this.filter = false;
      } else {
        this.shown = true;
        this.filter = true;
      }
    },
    onExpansionPanelClick(event) {
      if (event.target.classList.contains("v-expansion-panel-header--active")) {
        //alert("Panel is closing/now closed.")
      } else {
        //alert("Panel is opening/now open.")
      }
    },
    fetchVaribles() {
      this.variableItems = [];
      // alert('dd');
      apifactory
        .get_sdataheaders()
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            //alert(JSON.stringify(res.data));
            //this.variableItems = res.data;
            this.variableItems = [...Object.keys(res.data)];
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    fetchregion() {
      this.variableItems = [];
      // alert('dd');
      apifactory
        .api_get_project_region_list()
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
           // alert(JSON.stringify(res.data));
            //this.variableItems = res.data;
            this.dataregion = res.data.filter(a=>a != "national");
            if (this.dataregion.length > 0) {
              this.dataregionSelected = this.dataregion[0];
              this.isshowdataregion = true;
            } else {
              this.isshowdataregion = false;
            }
            this.feachdatanew();
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    fetchData() {
      //alert('dd');
      this.fetchdatatabledata();
    },
    feachdatanew() {
      this.isLoading = true
      this.saveAndSetStepParms_2();
     
    },
    fetchdatatabledata() {
      (this.data = []),
        apifactory
          .get_tabledata(
            this.timeRange1[0],
            this.timeRange1[1],
            this.timeRange2[0],
            this.timeRange2[1],
            this.timeRange3[0],
            this.timeRange3[1],
            this.prevstepQueryStringParmUrl
          )
          .then((res) => {
            // alert(res.id);

            if (res.status != 200) {
              //this.countryList = null;
              alert(res.message);
            } else {
              // alert(JSON.stringify(res.data));
              //this.variableItems = res.data;
              // alert();
              this.data = res.data;
            }
          })
          .catch(function (error) {
            console.warn(error);
          });
    },

    setdefaultvalues() {
      //timeRange1: ['2018-09-15', '2018-09-20'],
      this.timeRange1[0] = "2019-09-15";
      this.timeRange1[1] = "2020-09-20";
      this.timeRange2[0] = "2019-09-15";
      this.timeRange2[1] = "2020-09-20";
      this.timeRange3[0] = "2019-09-15";
      this.timeRange3[1] = "2020-09-20";
      this.fillIndependentVariables();
      //this.fillgetstep2output();
    },
    
    onnextclick() {
      this.saveAndSetStepParms();
      // this.$router.push('/sessionalitysetting');
    },
    onBackclick() {
      this.$router.push("/settingproject");
    },
    saveAndSetStepParms() {
      let url_querystring = "trend=0&season=0&decay=0";

      apifactory
        .addParameterBySteps("3", url_querystring)
        .then((res) => {
          //alert(JSON.stringify(res));
          if (res.status != 200) {
            // return false;
            alert("Sorry");
          } else {
            storagefactory.setcurrentstep(globalclass.PARAM_Step_MDP_S);
            this.$router.push("/dataprocess");
            //this.$router.push("/sessionalitysetting");
            //dataprocess
          }
        })
        .catch(function (error) {
          alert(error);
          // return false;
        });
    },

     saveAndSetStepParms_2() {
      let start1= this.timeRange1[0];
      let end1=  this.timeRange1[1];
      let start2= this.timeRange2[0];
      let  end2=this.timeRange2[1];
      let start3=this.timeRange3[0];
      let end3= this.timeRange3[1];
      let region= this.dataregionSelected;  
         
      let url_querystring = "start1=" + start1 + "&end1=" + end1 + "&start2=" + start2 + "&end2=" + end2 + "&start3=" + start3 + "&end3=" + end3 + "&region=" + region + "";

      apifactory
        .addParameterBySteps("2", url_querystring)
        .then((res) => {
          //alert(JSON.stringify(res));
          if (res.status != 200) {
            // return false;
            alert("Sorry");
          } else {
            this.fillgetstep2output();
          }
        })
        .catch(function (error) {
          alert(error);
          // return false;
        });
    },

    getParametrOfPrvStep() {
      this.prevstepQueryStringParm = "";
      apifactory
        .gettheParameterByProjectStepSummary()
        .then((res) => {
          if (res.status != 200) {
            this.prevstepQueryStringParm = "";
            // alert(this.processdataitems.length);
          } else {
            this.prevstepQueryStringParm = res.data;
            let strurl = "";
            for (var k in this.prevstepQueryStringParm) {
              if (k != "step") {
                strurl =
                  strurl + k + "=" + this.prevstepQueryStringParm[k] + "&";
                // alert( this.prevstepQueryStringParm[k]);
              }
            }
            strurl = strurl.slice(0, -1);
            this.prevstepQueryStringParmUrl = strurl;
            this.fetchVaribles();
            this.fetchData();
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },

    //new methods
    fillIndependentVariables() {
      this.Independentvariables = [];
      // alert('dd');
      apifactory
        .api_get_project_variable_list()
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            //this.variableItems = res.data;
            this.Independentvariables = res.data.independent_var;
            this.copiedItems = [...this.Independentvariables]
            this.IndependentvariablesSelected = res.data.independent_var.slice(0,5);
            this.dependentvariables = res.data.dependent_var;

            //alert(JSON.stringify(this.Independentvariables));
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },

    fillgetstep2output() {
      this.step2output = [];
      //alert(this.dataregionSelected);
      apifactory
        .api_get_step2_output(
          this.timeRange1[0],
          this.timeRange1[1],
          this.timeRange2[0],
          this.timeRange2[1],
          this.timeRange3[0],
          this.timeRange3[1],
          this.dataregionSelected
        )
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            //this.variableItems = res.data;
            this.step2output = res.data;
            //alert(JSON.stringify(this.isshowdataregion));
            if (!this.isshowdataregion) {
              this.step2output_trend_data = this.step2output.trend_data;
              this.step2output_statistics_table =
                this.step2output.statistics_table;
              this.step2output_correlation = this.step2output.correlation;
            } else {
              this.step2output_trend_data = this.step2output.trend_data.filter(
                (a) => a.region == this.dataregionSelected
              );
              this.step2output_statistics_table =
                this.step2output.statistics_table.filter(
                  (a) => a.region == this.dataregionSelected
                );
              this.step2output_correlation =
                this.step2output.correlation.filter(
                  (a) => a.region == this.dataregionSelected
                );
            }

            this.$refs.ctrlheatmap.bindGraph(
              this.step2output_correlation,
              this.IndependentvariablesSelected,
               this.dependentvariables
            );
            this.$refs.ctrlboxplot.bindchart(
              this.step2output_statistics_table,
              this.IndependentvariablesSelected,
              this.Independentvariables
            );
            this.$refs.ctrltbl.binddata(
              this.step2output_statistics_table,
              this.IndependentvariablesSelected
            );
            //this.$refs.ctrlbarchart.fetchVaribles(this.dependentvariables);

            //alert(   this.dataregionSelected);

            this.$refs.ctrlbarchart.bindData(
              this.step2output_trend_data,
              this.IndependentvariablesSelected,
              this.dependentvariables,
              this.dataregionSelected
            );
            this.shown = false;
            this.filter = false;
            this.isLoading = false
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
  },

  mounted() {

    this.fetchregion();
    this.setdefaultvalues();
    //this.getParametrOfPrvStep();

    this.fetchVaribles();
    this.fetchData();

    //this.feachdatanew();
    // this.fetchData();
  },
  created() {},
  /*
   watch: {
     step2output(){
 this.$refs.ctrlheatmap.bindGraph(
              this.step2output_correlation,
              this.IndependentvariablesSelected
            );
           
     }
   }*/
};
</script>

<style scoped>
.filter-icon {
  padding-left: 10px !important;
  padding-right: 2px !important;
  margin-bottom: 10px !important;
  height: 20px !important;
  width: 20px !important;
}
</style>
